const shopConfigurationStatusForSelection = [
	'Created',
	'Active',
	'Locked',
	'Deleted',
].map(key => {
	return { id: key, name: key };
});

export { shopConfigurationStatusForSelection };
